// assets/cart-cashback.js
(function () {
  'use strict';

  /*───────────────────────────────────────────────*
   * Utilitários                                   *
   *───────────────────────────────────────────────*/
  const parseBRL = str =>
    parseFloat(
      str
        .replace(/[^\d,\.]/g, '')
        .replace(/\./g, '')
        .replace(/,/g, '.')
    );

  const formatBRL = num =>
    num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  /*───────────────────────────────────────────────*
   * 1) Cashback no carrinho principal             *
   *───────────────────────────────────────────────*/
  function updateCartCashback() {
    const totalEl = document.querySelector('p.totals__total-value');
    const cbBox   = document.getElementById('CartCashbackInfo');
    if (!totalEl || !cbBox) return;

    let textEl = cbBox.querySelector('.cashback-text');
    if (!textEl) {
      textEl = document.createElement('span');
      textEl.className = 'cashback-text';
      cbBox.insertBefore(textEl, cbBox.querySelector('.cashback-link'));
    }

    const total = parseBRL(totalEl.textContent);
    if (isNaN(total)) return;

    textEl.textContent = `Ganhe ${formatBRL(total * 0.10)} de cashback`;
  }

  /*───────────────────────────────────────────────*
   * 2) Cashback em cada Quick-Add modal           *
   *───────────────────────────────────────────────*/
  function updateQuickAddCashback(
    quickInfo = document.querySelector('.quick-add-modal__content-info')
  ) {
    if (!quickInfo) return;

    /* preço unitário (sale, regular ou last) */
    const priceEl = quickInfo.querySelector(
      '.price-item--last, .price-item--regular, .price-item--sale'
    );
    if (!priceEl) return;
    const unit = parseBRL(priceEl.textContent.trim());
    if (isNaN(unit)) return;

    /* quantidade selecionada (padrão = 1) */
    const qtyEl = quickInfo.querySelector('.quantity__input');
    const qty   = parseInt(qtyEl?.value || '1', 10) || 1;

    /* link que mostra o texto */
    const linkEl = quickInfo.querySelector(
      '.product-cashback-box .cashback-link'
    );
    if (!linkEl) return;

    const newText = `Ganhe ${formatBRL(unit * qty * 0.10)} de cashback • Saiba mais`;
    if (linkEl.textContent.trim() === newText) return; // já atualizado

    linkEl.textContent      = newText;
    linkEl.style.whiteSpace = 'nowrap';
    linkEl.style.display    = 'inline-block';

    /* garante que o wrapper esteja visível */
    const box = quickInfo.querySelector('.product-cashback-box');
    if (box) box.style.display = 'flex';
  }

  /*───────────────────────────────────────────────*
   * 3) Inicialização                              *
   *───────────────────────────────────────────────*/
  document.addEventListener('DOMContentLoaded', () => {
    updateCartCashback();
    updateQuickAddCashback();
  });

  /*───────────────────────────────────────────────*
   * 4) Observers / Eventos – carrinho principal   *
   *───────────────────────────────────────────────*/
  const totals = document.querySelector('.totals');
  if (totals) {
    new MutationObserver(updateCartCashback).observe(totals, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  document.querySelectorAll('p.totals__total-value').forEach(el =>
    new MutationObserver(updateCartCashback).observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
    })
  );

  ['cart:updated', 'cart:refresh', 'cart:refresh:completed', 'ajax:complete'].forEach(evt =>
    document.addEventListener(evt, updateCartCashback)
  );

  /* fallback de 1 s */
  let lastTotal = null;
  setInterval(() => {
    const t = document.querySelector('p.totals__total-value');
    if (!t) return;
    const c = parseBRL(t.textContent);
    if (!isNaN(c) && c !== lastTotal) {
      lastTotal = c;
      updateCartCashback();
    }
  }, 1000);

  /*───────────────────────────────────────────────*
   * 5) Observers / Polling – Quick-Add modais     *
   *───────────────────────────────────────────────*/

  /* detecta modais recém-inseridos */
  new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        const qi =
          node.matches('.quick-add-modal__content-info')
            ? node
            : node.querySelector?.('.quick-add-modal__content-info');
        if (qi) attachQuickAddObserver(qi);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* já existentes no carregamento */
  document
    .querySelectorAll('.quick-add-modal__content-info')
    .forEach(attachQuickAddObserver);

  /* helper que instala observer interno e 1º cálculo */
  function attachQuickAddObserver(qi) {
    if (qi._cashbackObserver) return; // já tem
    updateQuickAddCashback(qi);
    qi._cashbackObserver = new MutationObserver(() =>
      updateQuickAddCashback(qi)
    );
    qi._cashbackObserver.observe(qi, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  /* polling leve (0.5 s) para pegar alterações de qty */
  setInterval(() => {
    document
      .querySelectorAll('.quick-add-modal__content-info')
      .forEach(updateQuickAddCashback);
  }, 500);
})();
